<template>
    <div class="flex items-center justify-center h-screen">
        <vs-row vs-justify="center">
            <vs-col type="flex" vs-justify="center" vs-align="center" vs-w="6">
                <vs-card>
                    <div>
                        <h3>Acceso Denegado</h3>
                    </div>
                    <div>
                        <span>No tienes la autorización para poder visualizar el contenido.</span>
                    </div>
                    
                </vs-card>
            </vs-col>
        </vs-row>
    </div>
</template>
<script>
    import MetodosGenerales from '@/utils/metodosgenerales.vue.js';
    import {mapState} from 'vuex';
    export default {
        data() {
            return {
                timer: 3
            }
        },
        computed: {
            ...mapState(['domain', 'informationPage'])
        },
        methods: {
        },
    }
</script>